import isFilledUp from './fields/isFilledUp'

const validatePassword = (name, password) => {
  const errors = {}

  if (typeof password === 'undefined') {
    return {}
  }
  if (!isFilledUp(password)) {
    errors[`${name}_required`] = 'Password should not be blank'
  }
  if (!(password && password.length >= 10)) {
    errors[`${name}_length`] = 'Password should be least 10 characters'
  }
  if (!/[A-Z]+/.test(password)) {
    errors[`${name}_with_capital`] =
      'Password must include at least one capital letter'
  }
  if (!/[0-9]+/.test(password)) {
    errors[`${name}_with_numeric`] = 'Password must include at least one number'
  }
  if (!/[ !@#$%^&*()_=+{}[\]\\|;:'"<,>.?/~`-]+/.test(password)) {
    errors[`${name}_with_symbol`] =
      'Password must include at least one special character (!@#$%^)'
  }
  if (!isFilledUp(password)) {
    errors[`${name}_not_common`] = 'Password should not be blank'
  }
  return errors
}

const validateConfirmPassword = (name, confirmPassword, password) => {
  if (!isFilledUp(confirmPassword)) {
    return { [name]: 'Please confirm your password' }
  }
  if (password !== confirmPassword) {
    return { [name]: 'Passwords do not match' }
  }

  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { password = '', confirm_password: confirmPassword } = values

  return {
    ...validatePassword('password', password),
    ...validateConfirmPassword('confirm_password', confirmPassword, password),
  }
}

export default validate
